import { render } from "./LecturerProcess.vue?vue&type=template&id=715b7c16&scoped=true"
import script from "./LecturerProcess.vue?vue&type=script&lang=js"
export * from "./LecturerProcess.vue?vue&type=script&lang=js"

import "./LecturerProcess.vue?vue&type=style&index=0&id=715b7c16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715b7c16"]])

export default __exports__